import { SITE_HG, COUNTRY } from '@/config';

const DEDICATED_LINUX_SERVER_URL_BY_BRAND = {
  ar: `${SITE_HG}/servidores-dedicados`,
  bo: `${SITE_HG}/servidores-dedicados`,
  br: `${SITE_HG}/servidor-dedicado`,
  cl: `${SITE_HG}/servidores-dedicados`,
  co: `${SITE_HG}/servidores-dedicados`,
  cr: `${SITE_HG}/servidores-dedicados`,
  do: `${SITE_HG}/servidores-dedicados`,
  ec: `${SITE_HG}/servidores-dedicados`,
  mx: `${SITE_HG}/servidores-dedicados`,
  pa: `${SITE_HG}/servidores-dedicados`,
  py: `${SITE_HG}/servidores-dedicados`,
  pe: `${SITE_HG}/servidores-dedicados`,
  sv: `${SITE_HG}/servidores-dedicados`,
  uy: `${SITE_HG}/servidores-dedicados`,
};

export const DEDICATED_LINUX_SERVER_URL = DEDICATED_LINUX_SERVER_URL_BY_BRAND[COUNTRY]
  || DEDICATED_LINUX_SERVER_URL_BY_BRAND.br;
